import { render, staticRenderFns } from "./classTabs.vue?vue&type=template&id=1d4f1852&scoped=true&"
import script from "./classTabs.vue?vue&type=script&lang=js&"
export * from "./classTabs.vue?vue&type=script&lang=js&"
import style0 from "./classTabs.vue?vue&type=style&index=0&id=1d4f1852&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f1852",
  null
  
)

export default component.exports